import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ITotalLoopByShiftTableDetail } from '../../../interfaces/report-loop-by-operator';
import { ITableHeaderParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { ITableDataParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-data-params';
import { TableConfigService } from '../../../../../../../projects/common/src/app/services/table/table-config.service';
import { ITableExtraParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-extra-params';
import { ITableConfig } from '../../../../../../../projects/common/src/app/interfaces/table/table-config';
import { objectPathExists } from 'projects/common/src/app/services/utils/utilities';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';

@Component({
  selector: 'app-transfer-by-machine-shift-table',
  templateUrl: './transfer-by-machine-shift-table.component.html',
  styleUrls: ['./transfer-by-machine-shift-table.component.scss'],
})
export class TransferByMachineShiftTableComponent implements OnChanges {
  @Input() public transferByMachineTable: ITotalLoopByShiftTableDetail[];
  @Input() public isTruck: boolean;

  public tableConfig: ITableConfig;

  constructor(private tableConfigService: TableConfigService, private _langService: LanguageService) {}

  /**
   * On component change
   */
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.transferByMachineTable && this.transferByMachineTable) {
      this.setTableConfig(this.transferByMachineTable);
    }
  }

  /**
   * Function to set table config
   */
  private setTableConfig(tableData: any[]): void {
    const nameHeader = Object.keys(
      tableData.map((td, index, array) => {
        return array[index];
      })[0],
    ).map((td) => {
      return td;
    });

    const translateHeader =
      nameHeader[2] === 'totalLoopByMachine' && this.isTruck
        ? this._langService.message('loops')
        : this._langService.message('shelves') || (nameHeader[2] === 'totalLoopByOperator' && this.isTruck)
        ? this._langService.message('loops')
        : this._langService.message('shelves');

    const headerParams: ITableHeaderParams = {
      data: tableData,
      replaceColumnName: [
        { prevName: nameHeader[1], newName: nameHeader[1] === 'machineName' ? 'machineType' : 'operatorName' },
        {
          prevName: nameHeader[2],
          newName: translateHeader,
        },
      ],
      excludeColumns: ['machineId', 'shiftId', 'tagId', 'operatorId'],
    };
    const datasetParams: ITableDataParams = {
      tableData,
      colorConfig: [{ field: 'machineName', isBold: true }],
      excludeColumns: ['machineId', 'shiftId', 'tagId', 'operatorId'],
    };
    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    const minimalRows = 6;
    const quantityPerPage = tableData.length ? tableData.length : minimalRows;
    const extraParams: ITableExtraParams = {
      noDataMsg: 'm034',
      disableFooter: true,
      minimalRows,
      quantityPerPage: quantityPerPage < minimalRows ? minimalRows : quantityPerPage,
    };

    this.tableConfig = { header, dataset, extraParams };
  }
}
